// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import styles from "./styles.css"

export default class Card extends Component {
  props: {
    style?: mixed,
    children?: mixed[],

    className?: string,

    decor?: boolean,
    decorStyle?: mixed,
    // TODO: Add decorPoisiton and update DebtPhaseContactHistory
  }

  render () {
    const contentClassName = this.props.className || ""

    return (
      <div className={styles.root} style={this.props.style}>
        { this.props.decor ?
          <div style={this.props.decorStyle} className={styles.decor}/>
          : "" }
        <div className={[ styles.content, contentClassName ].join( " " )}>
          {this.props.children}
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Card/index.js